import { useState, useEffect } from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';
import { ClockCounterClockwise, User, MagnifyingGlass } from '@phosphor-icons/react';
import { Input } from '../components/ui/input';
import SortableTable from '../components/SortableTable';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ACTION_COLORS = {
  accept_order: 'bg-[#28cd8c]/10 text-[#28cd8c]',
  reject_order: 'bg-[#ea4b5a]/10 text-[#ea4b5a]',
  create_product: 'bg-[#7d64ff]/10 text-[#7d64ff]',
  update_inventory: 'bg-[#f6a609]/10 text-[#f6a609]',
  approve_kyc: 'bg-[#28cd8c]/10 text-[#28cd8c]',
  reject_kyc: 'bg-[#ea4b5a]/10 text-[#ea4b5a]',
};

export default function AuditLogsPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/audit-logs`, { withCredentials: true })
      .then(res => setLogs(res.data.logs || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = logs.filter(l => {
    if (!search) return true;
    const q = search.toLowerCase();
    return l.user_name?.toLowerCase().includes(q) || l.action?.toLowerCase().includes(q) || l.resource_id?.toLowerCase().includes(q) || l.details?.toLowerCase().includes(q);
  });

  return (
    <DashboardLayout title="Audit Logs" subtitle="Track all system actions">
      <div className="bg-white border border-[#e5e5ea] rounded-lg p-4 mb-4">
        <div className="relative">
          <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5a5c87]" />
          <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search logs..." className="pl-10" data-testid="audit-search" />
        </div>
      </div>
      <SortableTable
        columns={[
          { key: 'user_name', label: 'User', render: (v) => (
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full bg-[#f2f0ff] flex items-center justify-center flex-shrink-0"><User size={13} className="text-[#7d64ff]" /></div>
              <span className="font-medium text-sm">{v}</span>
            </div>
          )},
          { key: 'action', label: 'Action', render: v => <span className={`px-2 py-0.5 rounded text-xs font-bold ${ACTION_COLORS[v] || 'bg-gray-100 text-gray-600'}`}>{v?.replace(/_/g, ' ')}</span> },
          { key: 'resource_type', label: 'Resource' },
          { key: 'resource_id', label: 'Resource ID', render: v => <span className="font-mono text-xs">{v}</span> },
          { key: 'details', label: 'Details', render: v => <span className="text-xs text-[#5a5c87] truncate max-w-[250px] inline-block">{v || '-'}</span> },
          { key: 'timestamp', label: 'Time', render: v => new Date(v).toLocaleString() },
        ]}
        data={filtered}
        pageSize={20}
        emptyMessage="No audit logs found"
        emptyIcon={ClockCounterClockwise}
      />
    </DashboardLayout>
  );
}
